module.exports = __webpack_public_path__ + "img/banner_cim_guandu.d0ccbf29.png";